import React, { useCallback, createContext, useContext, useMemo, useState } from 'react';

const ReadyContext = createContext({ isReady: false, setReady: () => {} });

export const useHarReady = () => useContext(ReadyContext);

export const HarReadyProvider = ({ children }: { children: React.ReactNode }) => {
  const [isReady, setIsReady] = useState(false);

  const setReady = useCallback(() => {
    setIsReady(true);
  }, []);

  const value = useMemo(() => ({ isReady, setReady }), [isReady, setReady]);

  return <ReadyContext.Provider value={value}>{children}</ReadyContext.Provider>;
};
